import React from "react"
import InspirationSearchContainer from "../../containers/InspirationSearchContainer"

const InspirationSearchPage = () => {
  return <InspirationSearchContainer />
}
export default InspirationSearchPage
